import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { analytics } from 'common/services/analytics/Analytics';
import styles from './Pages.module.scss';

const NotFoundPage: React.FC = () => {
  const handleLinkClick = (): void => {
    analytics.send({
      eventName: 'back_home_click',
    });
  };

  useEffect(() => {
    const currentPath = window.location.pathname;

    analytics.send({
      eventName: 'error_404',
      data: {
        path: currentPath,
      },
    });
  }, []);
  return (
    <section className={styles.not_found_wrapper}>
      <div className={styles.not_found_title}>OOPS!</div>
      <div className={styles.not_found_description}>
        that page doesn&apos;t exist
      </div>
      <div className={styles.not_found_btn_wrapper}>
        <Link
          onClick={handleLinkClick}
          className={styles.not_found_home_link}
          to="/"
        >
          Go Back Home
        </Link>
      </div>
    </section>
  );
};

export default NotFoundPage;
